import { useRef } from 'react';

import { queries, Policy, IIBError } from '@core/api';
import { logger } from '@lib/logger';

import { shouldShowExistingInsuranceModal } from '../existingInsuranceUtils';

export const useExistingInsuranceModalCheck = (onShow: () => void): void => {
  const hasShownRef = useRef(false);

  queries.policies.useGetPoliciesListServer({
    options: {
      enabled: true,
      onSuccess: (data) => {
        const policies: Policy[] = data?.data?.result?.policiesList ?? [];

        if (shouldShowExistingInsuranceModal(policies, hasShownRef.current)) {
          hasShownRef.current = true;
          onShow();
        }
      },
      onError: (error: IIBError | unknown) => {
        const casted = error as IIBError;

        if (casted?.code === 'Unauthorized') {
          logger.warn('User unauthorized while fetching insurance policy');
        } else {
          logger.error(
            'Unexpected error while fetching insurance policy',
            error,
            {
              code: casted?.code,
              message: casted?.message,
              status: casted?.status,
              data: casted?.data
            }
          );
        }
      }
    }
  });
};
